import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { PhoneNumberResponse } from '../models/phone-number.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface PhoneNumberDrawerOptions {
  phoneNumberId?: number;
}

interface DrawerState {
  isOpen: boolean;
  options: PhoneNumberDrawerOptions;
}

@Injectable({ providedIn: 'root' })
export class PhoneNumberDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state = new BehaviorSubject<DrawerState>({ isOpen: false, options: {} });
  readonly state$ = this.state.asObservable();

  private readonly savedSubject = new Subject<PhoneNumberResponse>();
  readonly saved$ = this.savedSubject.asObservable();

  open(options: PhoneNumberDrawerOptions = {}): void {
    if (!this.state.value.isOpen) this.registry.opened();
    this.state.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state.value.isOpen) this.registry.closed();
    this.state.next({ isOpen: false, options: {} });
  }

  notifySaved(phoneNumber: PhoneNumberResponse): void {
    this.savedSubject.next(phoneNumber);
  }
}
